import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import { App as Home } from 'app/containers/App';
import { Login } from 'app/containers/Login';
import { Kry } from 'app/containers/Kry';
import { Demo } from './containers/Demo';

export const App = () => (
	<Switch>
		<Route exact path="/" component={Home} />
		<Route exact path="/login" component={Login} />
		<Route exact path="/kry" component={Kry} />
		<Route exact path="/demo" component={Demo} />
	</Switch>
);
